import { useEffect } from 'react';

// Lightweight per-page SEO: sets <title>, <meta description>, canonical, and og tags.
const Seo = ({ title, description, canonical, image = 'https://www.thecaloriesnap.com/icon-512.png' }) => {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (selector, attr, value) => {
      if (!value) return;
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement('meta');
        const [key, val] = selector.replace(/[[\]"]/g, '').split('=');
        el.setAttribute(key, val);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    setMeta('meta[name="description"]', 'content', description);
    setMeta('meta[property="og:title"]', 'content', title);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[property="og:image"]', 'content', image);
    setMeta('meta[property="og:type"]', 'content', 'website');
    setMeta('meta[name="twitter:card"]', 'content', 'summary_large_image');
    setMeta('meta[name="twitter:title"]', 'content', title);
    setMeta('meta[name="twitter:description"]', 'content', description);
    setMeta('meta[name="twitter:image"]', 'content', image);

    // Canonical link
    let link = document.head.querySelector('link[rel="canonical"]');
    if (canonical) {
      if (!link) { link = document.createElement('link'); link.setAttribute('rel', 'canonical'); document.head.appendChild(link); }
      link.setAttribute('href', canonical);
    }
    // Robots meta: noindex on private /app routes to avoid the "same title" penalty from crawlers hitting them.
    const isPrivate = typeof window !== 'undefined' && window.location.pathname.startsWith('/app');
    let robots = document.head.querySelector('meta[name="robots"]');
    if (!robots) { robots = document.createElement('meta'); robots.setAttribute('name', 'robots'); document.head.appendChild(robots); }
    robots.setAttribute('content', isPrivate ? 'noindex, nofollow' : 'index, follow');
  }, [title, description, canonical, image]);

  return null;
};

export default Seo;
